/** Allowlist aus Vite-ENV — zusätzlich kann `profiles.is_superuser` in der DB gesetzt sein (siehe Einstellungen / API). */
export function isSuperuserEmail(email: string | null | undefined): boolean {
  const raw = import.meta.env.VITE_SUPERUSER_EMAILS || '';
  const set = new Set(
    raw
      .split(/[,;]/)
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean)
  );
  return Boolean(email && set.has(email.trim().toLowerCase()));
}
